import {
  Component, ComponentInterface, Prop, State, h,
} from '@stencil/core';
import { PesRouterStore } from '@pes-ui/components/dist/collection';
import { CAASContentOverviewSlotName } from '@pes-ui/utils';
import { PBSStore } from '../app-playground/pes-testing-control-panel/store';

@Component({
  tag: 'pes-catalog-wrapper',
})
export class PesCatalogWrapper implements ComponentInterface {
  @Prop({ attribute: 'global-configs-url' }) globalConfigsURL: string;

  @State() showDiscountedPriceButton = true;

  // Lifehack to force render
  @State() updateCount = 0;

  @State() productIdToShow;

  showPanel = window.location.search.indexOf('hide-panel=true') === -1;

  constructor() {
    // Lifehack to force render
    PBSStore.on('set', () => this.updateCount++);
  }

  private getDiscountPrice() {
    this.showDiscountedPriceButton = false;
  }

  private renderDiscountedPriceSlot() {
    return (
      <span slot="discounted-price">
        {this.showDiscountedPriceButton && (
          <button style={{ width: '100%' }} onClick={() => this.getDiscountPrice()}>
            View Your Price
          </button>
        )}
        {!this.showDiscountedPriceButton && <span>Your price: 100.500 USD</span>}
      </span>
    );
  }

  private renderOverViewTabContent() {
    return (
      <h1 slot={CAASContentOverviewSlotName}>
        Content for SDL CAAS overview tab
      </h1>
    );
  }

  public getSearchParams() {
    try {
      return JSON.parse(PBSStore.get('searchParams'));
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  private get pesCatalog() {
    return (
      <pes-catalog
        global-configs-url={this.globalConfigsURL}
        slot={!PBSStore.get('usePesRouter') ? 'pes-app' : null}
        host={PBSStore.get('host')}
        siteType={PBSStore.get('siteType')}
        showCustomPrice={PBSStore.get('showCustomPrice')}
        showCatalogPrice={PBSStore.get('showCatalogPrice')}
        showBreadcrumbs={PBSStore.get('showBreadcrumbs')}
        country={PBSStore.get('country')}
        language={PBSStore.get('language')}
        page={PBSStore.get('page')}
        pageId={PBSStore.get('pageId')}
        showDocuments={PBSStore.get('showDocuments')}
        showBuyOnline={PBSStore.get('showBuyOnline')}
        showCompare={PBSStore.get('showCompare')}
        showFaq={PBSStore.get('showFaq')}
        showRecentlyViewed={PBSStore.get('showRecentlyViewed')}
        substitutionLabelShort={PBSStore.get('substitutionLabelShort')}
        searchParams={this.getSearchParams()}
        ddcAppSource={PBSStore.get('ddcAppSource')}
        ddcAllProductsUrl={PBSStore.get('ddcAllProductsUrl')}
        userAccessToken={PBSStore.get('ddcAccessToken')}
        userProfile={PBSStore.get('ddcUserProfile')}
        isPanelActive={true}
      >
        {PBSStore.get('showDiscountedPrice') && this.renderDiscountedPriceSlot()}
        {PBSStore.get('showCAASContentSlot') && this.renderOverViewTabContent()}
      </pes-catalog>
    );
  }

  private get pesCatalogApp() {
    switch (PBSStore.get('appType')) {
      case 'pesCatalog':
        return PBSStore.get('usePesRouter') ? (
          <pes-router
            store={PesRouterStore}
            slot="pes-app"
            navigation={PBSStore.get('pesRouterNavigation')}
            base_dir={PBSStore.get('base_dir')}
          >
            {this.pesCatalog}
          </pes-router>
        ) : (
          this.pesCatalog
        );
    }
  }

  render(): void {
    return <pes-app-playground key={this.updateCount}>{this.pesCatalogApp}</pes-app-playground>;
  }
}
